let unblock = null; // Initialize with null

export const setUnblock = (unblockFn) => {
  unblock = unblockFn; // Set unblock function
};

export const getUnblock = () => unblock; // Get unblock function
